import { setHeader } from "@/util/set-header";
import React from "react";
import "./booking-detail.less";
import { NoticeBar, Steps, Button, Modal, Toast } from "antd-mobile";
import { bookingDetailApi, cancelReserveApplyApi } from "@/api/sany";
import { PhotoProvider, PhotoConsumer } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import moment from "moment";
import { getUrlQueryDic } from "@/util/util";
const Step = Steps.Step


export default class BookingDetail extends React.Component<any,any> {
  state = {
    notice: '预订审核提交成功，请按时办理入住哦~',
    reason: '请选择退房原因',
    status: 'cancel' //  审核中:audit 已入住:checkin 已取消:cancel 已驳回:reject
  }
  detail: any = {}
  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
  }

  componentDidMount() {
    setHeader({title: '预订', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightComponent()})
    this.fetchDetail()
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightComponent() {
    // if (this.state.status === 'audit') {
      return (
        <img onClick={()=>this.callPhone()} src="/public/assets/img/call_icon.png" alt=""/>
      )
    // }
  }

  callPhone() {
    const tel = 'tel:' + this.detail.contactWay
    window.location.href = (tel)
  }

  async fetchDetail() {
    let id = ''
    const dic = getUrlQueryDic(this.props.location.search)
    if (dic.id) {
      id = dic.id
    } else if (this.props.location.state.id) {
      id = this.props.location.state.id
    }
    Toast.loading('加载中...')
    const {data} = await bookingDetailApi({id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.detail = data.data
      this.configNotice()
    } else {
      Toast.info(data.msg)
    }
  }

  configNotice() {
    let notice = '预订审核提交成功，请按时办理入住哦~'
    if (this.detail.status === '1') {
      notice = '预订审核提交成功，请按时办理入住哦~'
    } else if (this.detail.status === '4') {
      notice = '预订已通过，办理入住成功~'
    } else if (this.detail.status === '7') {
      notice = '预订申请已取消，需要预订请重新申请~'
    } else if (this.detail.status === '5') {
      notice = '预订申请已驳回，需要预订请重新申请~'
    } else if (this.detail.status === '6') {
      notice = '预订申请已失效，需要预订请重新申请~'
    }
    this.setState({
      notice
    })
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

  // 驳回原因
  rejectReasonComponent() {
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151', width: '100px'}}>驳回原因：</span>
          <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.detail.reject_reason}</span>
        </div>
      </div>
    )
  }

  // 步骤条
  stepComponent() {
    const status = (this.detail.status !== '1' && this.detail.status !== '2') ? 'finish' : 'wait'
    const title = (this.detail.status !== '1' && this.detail.status !== '2') ? this.detail.status_name : '已入住'
    let step3Icon = '/public/assets/img/step_room.png'
    if (this.detail.status === '4') {
      step3Icon = '/public/assets/img/step_room_select.png'
    } else if (this.detail.status === '1' || this.detail.status === '2') {
      step3Icon = '/public/assets/img/step_room.png'
    } else {
      step3Icon = '/public/assets/img/step_end.png'
    }
    const applyTime =  (this.detail.apply_time && this.detail.apply_time.length > 5) ? moment(this.detail.apply_time).format('yyyy-MM-DD') : this.detail.apply_time
    const endTime = (this.detail.update_time && this.detail.update_time.length > 5) ? moment(this.detail.update_time).format('yyyy-MM-DD') : this.detail.update_time
    return (
      <div className="step-body">
        <Steps direction="horizontal" size="small">
          <Step status="finish" title={this.customTitle('预订申请', 'finish')} description={this.customDesc(applyTime, 'finish')} icon={this.customIcon('/public/assets/img/step_start_select.png')} />
          <Step status="wait" title={this.customTitle('待审核', 'finish')} description={this.customDesc('', 'finish')} icon={this.customIcon('/public/assets/img/step_loading_select.png')} />
          <Step status="wait" title={this.customTitle(title, status)} description={this.customDesc(endTime, status)} icon={this.customIcon(step3Icon)} />
        </Steps>
      </div>
    )
  }

  customTitle(title: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <div style={{fontSize:'12px', color: color}}>{title}</div>
    )
  }

  customDesc(desc: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <span style={{color: color, fontSize: '12px'}}>{desc}</span>
    )
  }

  customIcon(img: string) {
    return (
      <img src={img} alt="" style={{width: '25px', height: '25px'}}/>
    )
  }

  // 去签约
  goSignComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goSignClick()}>去签约</Button>
          <span style={{fontSize: '12px', color: '#515151'}}>房间签约后到期可正常入住，马上签约吧~</span>
        </div>
      </div>
    )
  }

  goSignClick() {
    this.props.history.push({pathname: '/sany/sign', state: {contractId: this.detail.contract_id}})
  }

  // 预订房间信息
  dormInfoComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-top">
            <span style={{color: '#868686', fontSize: '16px'}}>{this.detail.store_name}</span>
            <span style={{color: '#1b1b1b', fontSize: '14px'}}>{this.detail.building_no} {this.detail.room_no} {this.detail.bed_no}</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.room_property_name}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.room_type_name}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住时间：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.checkin_day}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.pay_type_name}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>节点处理人：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.node_name}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>节点处理人电话：</span>
              <span style={{color: '#868686', fontSize: '13px'}}><a href={`tel:${this.detail.node_phone}`}>{this.detail.node_phone}</a></span>
            </div>
            {this.detail.pay_type === '2' ?
            <div className="between-row" style={{height: '40px'}}>
            <span style={{color: '#434343', fontSize: '13px'}}>扣费部门：</span>
            <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.pay_type_departmentName}</span>
          </div> : null}
          </div>
          <div className="dorm-info-bottom">
            <span style={{color: '#434343', fontSize: '13px'}}>附件：</span>
            {this.attachmentImageList()}
          </div>
        </div>
      </div>
    )
  }

  // 构建图片数组
  attachmentImageList() {
    const imgs: [] = this.detail.img ?? [] 
    return (
      <PhotoProvider>
      {imgs.map((item: any, index) => (
        <PhotoConsumer key={index} src={item} intro={item}>
          <img src={item} alt="" style={{width: '47px', height: '55px', marginLeft: '10px'}}/>
        </PhotoConsumer>
      ))}
    </PhotoProvider>
    )
  }
  
  submitButton() {
    if (this.detail.status === '4' || this.detail.status === '2') {
      return
    } else {
      const title = this.detail.status === '1' ? '取消预订申请' : '重新提交预订申请'
      return (
        <Button className="submit-btn"  onClick={() => this.submitClick()}>{title}</Button>
      )
    }
  }

  submitClick() {
    if (this.detail.status === '1') {
      Modal.alert('取消预订', '取消预订申请后，将无法入住~', [
        { text: '暂不取消', onPress: () => console.log('cancel') },
        { text: '取消预订', onPress: () => this.cancelReserve() },
      ])
    } else {
      this.props.history.push({pathname: '/sany/book-room',state: {propertyType:this.detail.room_property}})
      sessionStorage.setItem('reservationType', 'reservation')
    }
  }

  async cancelReserve() {
    const id = this.detail.id
    Toast.loading('加载中...')
    const {data} = await cancelReserveApplyApi({id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      // this.fetchDetail()
      Toast.info('已取消')
      this.props.history.push({pathname: '/sany/dorm-list'})
    } else {
      Toast.show(data.msg)
    }
  }

  render() {
    return (
      <div className="booking-detail">
        {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
        {this.stepComponent()}
        {(this.detail.status === '4' && this.detail.contract_id && !this.detail.is_sign) ? this.goSignComponent() : null}
        {(this.detail.reject_reason && this.detail.reject_reason.length > 0) ? this.rejectReasonComponent() : null}
        {this.dormInfoComponent()}
        {this.submitButton()}
      </div>
    )
  }
}